import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router';
let screenIdentifier = 'deiveryPickupScreen';
import * as UserActions from './../actions/user_actions';
import { bindActionCreators } from 'redux';
import Dashboard from './dashboardScreen/dashboard';
import Modal from 'react-modal';
import _ from 'lodash';
import { ModalDialogCommon } from './modal_dialog_common';
// import ModelNotification from './dashboardScreen/notificationModel';
import * as serviceCallConfig from '../config/api_urls';

let allowPolling = true
let MainLayout = React.createClass({
    getInitialState() {
        return {
            isDeleting: false,
            selectedTab: '0', autoLogoutCalled: false, session_expired: false
        }
    },
    componentWillReceiveProps(nextProps) {

        if (nextProps.LogingDetails.sessionExpired && nextProps.LogingDetails.sessionExpired.status === 203) {
            this.setState({ session_expired: true })
        }
        if (this.state.autoLogoutCalled && nextProps.SessionLogoutResponse) {
            if (nextProps.SessionLogoutResponse.status == 200) {
                this.props.Dispatch(UserActions.user_log_out());
                this.setState({ autoLogoutCalled: false })
                localStorage.clear();
                this.props.router.push('/?timeout=1');
            } else {
                // need to show error msg from server response
            }
        }

    },
    componentWillMount() {
        allowPolling = true
    },
    componentWillUnmount() {
        allowPolling = false
    },
    componentDidMount() {
        this.logutTimmer();
        if (this.props.LogingDetails && this.props.LogingDetails.loginData && this.props.LogingDetails.loginData.data) {
            this.setState({ active: true })
        }

    },
    closebox() {
        this.props.Dispatch(UserActions.user_log_out());
        this.setState({ autoLogoutCalled: true })
        localStorage.clear();
        //  this.props.router.push('/?timeout=1');
    },
    modelNodification() {

        this.setState({
            isDeleting: true
        });

    },
    viewAll() {
        this.setState({
            isDeleting: false
        })
        this.props.router.push('/dashboard/moreNotifications')
    },
    subdata() {
        var currentState = this.state.active;
        this.setState({ active: !currentState })
    },
    storeTypeHandler(e) {
        if (e.target.className == 'active') {
            e.target.className = 'button';

        }

        else {
            e.target.className = 'button'

        }
    },
    menuClicked(event) {
        this.props.router.push(event.target.dataset.routerpath)
    },
    userAutoLogout() {

        if (allowPolling) {
            this.props.Dispatch(UserActions.logout());
            this.setState({ autoLogoutCalled: true })
        }

    },
    logutTimmer(endTime) {

        var that = this;
        previousInterVal && clearInterval(previousInterVal);

        let previousInterVal = setInterval(function () {

            if (allowPolling) {
                var currentTime = new Date().getTime();
                let ct = new Date(currentTime);


                let autoLogOutSetting = JSON.parse(localStorage.getItem("autoLogOut"));
                let updatedEndTime = window.localStorage ? autoLogOutSetting.autoLogOutTime : window.autoLogOutTime.autoLogOutTime;
                updatedEndTime = new Date(updatedEndTime).getTime();
                let ut = new Date(updatedEndTime)
                //  console.log("%c currentTime :" + ct , 'background: #222; color: #bada55');
                //  console.log("%c endTime :" +  ut , 'background: #2d2d2d; color: #bada55');
                //  console.log("%c"+currentTime >= updatedEndTime , 'background: #ccc; color: #222');

                if (currentTime >= updatedEndTime) {

                    that.userAutoLogout();
                    clearInterval(previousInterVal);
                }
            }
        }, 10000);


    },
    render() {

        if (!this.props.LogingDetails || !this.props.LogingDetails.loginData || !this.props.LogingDetails.loginData.data) {
            this.props.router.push('/');
            return false;
        }
        var ACTIVE = { borderLeft: ' 5px solid #fff', color: '#fff' }

        if (this.refs.sideMenu) {
            for (let i = 0; i < this.refs.sideMenu.children.length; i++) {
                this.refs.sideMenu.children[i].className = ''
            }


            //Super Admin
            if (this.props.LogingDetails.selectedUserRoleID === 1) {
                // Super admin Dashboard
                if (this.props.location.pathname === '/dashboard' || this.props.location.pathname === '/moreNotification') {
                    this.refs.superAadminDashboard.className = 'active';
                }
                // SuperAadminFacilities
                if (this.props.location.pathname === '/facilities' || this.props.location.pathname.includes('facilit')) {
                    this.refs.superAadminFacilities.className = 'active';
                }
                // SuperAadminQuestionnaire
                if (this.props.location.pathname === '/questionnaire') {
                    this.refs.superAadminQuestionnaire.className = 'active';
                }

                // SuperAadminTickets
                if (this.props.location.pathname === '/tickets') {
                    this.refs.superAdminTickets.className = 'active';
                }

                // // SuperAadminSettings
                // if (this.props.location.pathname === '/settingsScreen') {
                //     this.refs.superAadminSettings.className = 'active';
                // }

            }

            //Admin
            if (this.props.LogingDetails.selectedUserRoleID === 2) {
                // Admin Dashboard
                if (this.props.location.pathname === '/admin/dashboard') {
                    this.refs.adminDashboard.className = 'active';
                }
                // Aadmin Patientss
                if (this.props.location.pathname === '/patients' || this.props.location.pathname.includes('patient') || this.props.location.pathname.includes('add-unique-question') || this.props.location.pathname.includes('survey-analasys')) { //
                    this.refs.adminPatients.className = 'active';
                }
                // Aadmin Staff
                if (this.props.location.pathname === '/admin/staff' || this.props.location.pathname.includes('staff') || this.props.location.pathname.includes('Staff')) {
                    this.refs.adminStaff.className = 'active';
                }
                // Aadmin Clinic Settings
                if (this.props.location.pathname === '/admin/clinicsettings') {
                    this.refs.adminClinicSettings.className = 'active';
                }
                // // Aadmin Settings
                // if (this.props.location.pathname === '/admin/settings') {
                //     this.refs.adminSettings.className = 'active';
                // }
            }

            // Staff
            if (this.props.LogingDetails.selectedUserRoleID > 2) {
                // Aadmin Patientss
                if (this.props.location.pathname === '/staff/staffHome') {
                    this.refs.staffhome.className = 'active';
                }
            }
            if (this.props.LogingDetails.selectedUserRoleID > 2) {
                // Aadmin Patients
                if (this.props.location.pathname === '/patients' || this.props.location.pathname.includes('patient') || this.props.location.pathname.includes('survey') || this.props.location.pathname.includes('answerd-survey') || this.props.location.pathname.includes('survey-analasys') || this.props.location.pathname.includes('add-unique-question')) {
                    this.refs.adminPatients.className = 'active';
                }
            }

            // Settings for Super Admin, Admin, Staff
            if (this.props.location.pathname === '/settingsScreen') {
                this.refs.superAadminSettings.className = 'active';
            }
            // Logout
            if (this.props.location.pathname === '/logout') {
                this.refs.logout.className = 'active';
            }
        }

        return (
            <div className="app container-fluid no-padding">
                <div className="row">
                    <div className="col-xs-2 sidebar no-padding">

                        <aside className="primary-aside " >
                            <div className="logo text-center">
                                <Link to={this.props.LogingDetails.selectedUserRoleID == 1 ? "/dashboard" : this.props.LogingDetails.selectedUserRoleID == 2 ? "/admin/dashboard" : "/patients"}>
                                    {`${serviceCallConfig.BASE_URL}` != 'http://13.56.63.154:8071/api/v1/' ?
                                        <img alt="Mobi" src={require('./../images/logo.png')} /> :
                                        <span className='uat_logo'> <img alt="Mobi" src={require('./../images/logo_uat.png')} /> </span>}
                                    {/* <img alt="Mobi" src={require('./../images/logo_uat.png')} /> */}
                                </Link>
                            </div>
                            <ul className="sidemenu-buttons" ref='sideMenu'>

                                {/*Super Admin*/}
                                {this.props.LogingDetails.selectedUserRoleID == 1 && <li ref="superAadminDashboard" onClick={this.menuClicked} data-routerpath='/dashboard'>DASHBOARD </li>}
                                {this.props.LogingDetails.selectedUserRoleID == 1 && <li ref="superAadminFacilities" onClick={this.menuClicked} data-routerpath='/facilities'>CLINICS</li>}
                                {this.props.LogingDetails.selectedUserRoleID == 1 && <li ref="superAadminQuestionnaire" onClick={this.menuClicked} data-routerpath='/questionnaire'>SURVEYS</li>}

                                {/*Admin*/}
                                {this.props.LogingDetails.selectedUserRoleID == 2 && <li ref="adminDashboard" onClick={this.menuClicked} data-routerpath='/admin/dashboard'>DASHBOARD</li>}
                                {(this.props.LogingDetails.selectedUserRoleID >= 2 && this.props.LogingDetails.selectedUserRoleID <= 8) && <li ref="adminPatients" onClick={this.menuClicked} data-routerpath='/patients'>PATIENTS</li>}
                                {this.props.LogingDetails.selectedUserRoleID == 2 && <li ref="adminStaff" onClick={this.menuClicked} data-routerpath='/admin/staff'>STAFF</li>}
                                {this.props.LogingDetails.selectedUserRoleID == 2 && <li ref="adminClinicSettings" onClick={this.menuClicked} data-routerpath='/admin/clinicsettings'>CLINIC SETTINGS</li>}
                                {/*{this.props.LogingDetails.selectedUserRoleID == 2 && <li ref="adminSettings" onClick={this.menuClicked} data-routerpath='/admin/settings'>SETTINGS</li>}*/}
                                {(this.props.LogingDetails.selectedUserRoleID == 1 || this.props.LogingDetails.selectedUserRoleID == 2) && <li ref="superAdminTickets" onClick={this.menuClicked} data-routerpath='/tickets'>TICKETS</li>}


                                {/*Common Logout*/}
                                <li ref="superAadminSettings" onClick={this.menuClicked} data-routerpath='/settingsScreen'>MY SETTINGS</li>
                                {/*<li ref="logout" onClick={this.menuClicked} data-routerpath='/logout'>LOGOUT</li>*/}


                            </ul>

                            <span className="app-version">
                                <span>
                                    <Link
                                        to='#'
                                        onClick={(e) => {
                                            window.location = "mailto:MobiHelp@safarihealth.com";
                                            e.preventDefault();
                                        }}
                                    >
                                        Need help? Email MobiHelp@safarihealth.com
                                    </Link>
                                </span>
                                <span>Version :{`${serviceCallConfig.BASE_URL}` != 'http://13.56.63.154:8071/api/v1/' ? <span>PROD <b>0.0.0.29</b> </span> : <span>UAT <b>2.0.1</b> </span>} </span>
                            </span>
                        </aside>
                    </div>

                    <div className="col-xs-10 dashboard-content no-padding">

                        {this.props.children}

                    </div>
                    <Modal
                        ref='deleteAddressModal'
                        isOpen={this.state.isDeleting}
                        className='delete-prompt modalPopup'
                        contentLabel='modalPopup'>
                        <div className="white-box notification-text header-notifications">
                            <h3 onClick={this.viewAll}> VIEW ALL</h3>
                            <ul>
                                {_.map(this.props.Notifications, (Data, key) => {
                                    if (key < 3) {
                                        return (
                                            <li key={key}> {Data.firstName},{Data.lastName},{Data.role}{Data.status}<span className="pull-right">{(new Date(Data.requestDate)).getMinutes()}m ago</span></li>
                                        )
                                    }

                                })
                                }

                            </ul>

                        </div>
                    </Modal>

                </div>
                <div> {this.state.session_expired && <ModalDialogCommon message={"Your session has expired. Please log in again"} action={this.closebox} />}</div>
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        LogingDetails: state.User,
        Dashboard: state.Dashboard,
        SessionLogoutResponse: state.User.sessionLogoutResponse,
    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(MainLayout));



/** WEBPACK FOOTER **
 ** ./src/components/sideMenu.js
 **/